import { type FunctionComponent } from 'react';
import { ProductRebateWidget } from '../../../rebates/widgets/product-rebate-widget/product-rebate-widget.component';

export type RebateWidgetProps = {
	variantIds: number[];
	className?: string;
};

export const RebateWidget: FunctionComponent<RebateWidgetProps> = ({ variantIds, className }) => {
	return <ProductRebateWidget type="PLP" variantIds={variantIds} className={className} />;
};
